module.exports = __webpack_public_path__ + "media/AG-Business-Intelligence.bbeede9b.mp4";